import React, { useMemo, useState } from 'react';
import { Link } from "react-router-dom";

import Tagline from "../../components/tagline";
import Navbar from "../../components/navbar";
import Form from '../../components/form';
import TopDestinationOne from '../../components/top-destination-one';
import About from '../../components/about';
import Client from '../../components/client';
import Blogs from '../../components/blogs';
import Footer from '../../components/footer';
import Switcher from '../../components/switcher';

import ModalVideo from 'react-modal-video';
import '../../../node_modules/react-modal-video/scss/modal-video.scss'

import { usePackages } from '../../hooks/usePackages';
import RatingStars from '../../components/RatingStars';

import {FiMapPin} from '../../assets/icons/vander'

export default function Index(){
    const [isOpen, setOpen] = useState(false);
    const { packages, loading, error, refetch } = usePackages();

    const formatPrice = useMemo(
        () => (priceCents, currency = "USD") => {
            if (priceCents == null) return "";
            const amount = currency === "CLP" ? priceCents : priceCents / 100;
            return new Intl.NumberFormat("es-CL", {
                style: "currency",
                currency,
                minimumFractionDigits: currency === "CLP" ? 0 : 2,
            }).format(amount);
        },
        []
    );

    return(
        <>
        <Tagline/>
        <Navbar navclass="defaultscroll is-sticky tagline-height" navlight={true} manuclass="justify-end nav-light"/>
        <section className="relative md:pt-72 md:pb-60 py-36 table w-full items-center bg-[url('../images/bg/1.jpg')] bg-top bg-no-repeat bg-cover">
            <div className="absolute inset-0 bg-slate-900/40"></div>
            <div className="container relative">
                <div className="grid md:grid-cols-12 grid-cols-1 items-center mt-10 gap-[30px]">
                    <div className="lg:col-span-8 md:col-span-7 md:order-1 order-2">
                        <p className="text-3xl font-dancing text-white">La belleza de los descubrimientos</p>
                        <h1 className="font-bold text-white lg:leading-normal leading-normal text-4xl lg:text-6xl mb-6 mt-5 [text-wrap:balance]">Conociendo la <br/> región del Maule</h1>
                        <p className="text-white/70 text-xl max-w-xl">¿Estás planeando un viaje? ¡Organizaremos tu viaje con los mejores lugares y dentro del mejor presupuesto!</p>
                    </div>

                    <div className="lg:col-span-4 md:col-span-5 md:text-center md:order-2 order-1">
                        <button type="button" aria-label="Reproducir video de presentación" onClick={() => setOpen(true)} className="lightbox lg:h-24 h-20 lg:w-24 w-20 rounded-full shadow-lg dark:shadow-gray-800 inline-flex items-center justify-center bg-white hover:bg-red-500 text-red-500 hover:text-white duration-500 ease-in-out mx-auto">
                            <i className="mdi mdi-play inline-flex items-center justify-center text-3xl"></i>
                        </button>
                    </div>
                    <ModalVideo channel="youtube" youtube={{ mute: 0, autoplay: 0 }} isOpen={isOpen} videoId="S_CGed6E610" onClose={() => setOpen(false)}/>
                </div>
            </div>
        </section>

        <div className="container relative -mt-16 z-1">
            <Form/>
        </div>

        <section className="relative md:py-24 py-16 overflow-hidden">
            <TopDestinationOne/>

            <div className="container relative md:mt-24 mt-16">
                <div className="grid grid-cols-1 pb-8 text-center">
                    <h2 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold [text-wrap:balance]">Paquetes de tours</h2>

                    <p className="text-slate-400 max-w-xl mx-auto">¿Planeando un viaje? ¡Organizamos tu viaje con los mejores lugares y al mejor precio!</p>
                </div>

                {loading && <p className="text-center text-slate-400">Cargando paquetes…</p>}
                {error && (
                    <div className="text-center">
                        <p className="text-red-500">{error}</p>
                        <button type="button" onClick={refetch} className="mt-3 py-2 px-5 inline-block bg-red-500 hover:bg-red-600 text-white rounded-md">Reintentar</button>
                    </div>
                )}

                <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-6 gap-6">
                    {!loading && !error && packages.slice(0,6).map((item,index)=>{
                        const cover = item.images?.[0]?.url || item.hero_image_url || '';
                        return(
                            <div className="group rounded-md shadow dark:shadow-gray-700" key={item.id || index}>
                                <div className="relative overflow-hidden rounded-t-md shadow dark:shadow-gray-700 mx-3 mt-3">
                                    {cover ? (
                                        <img src={cover} width="400" height="240" loading="lazy" className="scale-125 group-hover:scale-100 duration-500 w-full h-[240px] object-cover" alt={item.title}/>
                                    ) : (
                                        <div className="h-[240px] bg-slate-200 dark:bg-slate-800 flex items-center justify-center text-slate-500">Sin imagen</div>
                                    )}

                                    <div className="absolute top-0 end-0 p-4">
                                        <button type="button" aria-label="Guardar en favoritos" className="size-8 inline-flex justify-center items-center bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-full text-slate-100 dark:text-slate-700 focus:text-red-500 dark:focus:text-red-500 hover:text-red-500 dark:hover:text-red-500"><i className="mdi mdi-heart text-[20px] align-middle"></i></button>
                                    </div>
                                </div>

                                <div className="p-4">
                                    <p className="flex items-center text-slate-400 font-medium mb-2"><FiMapPin className="text-red-500 size-4 me-1"></FiMapPin> {item.place || item.destination?.name}</p>
                                    <Link to={`/tour-detail-one/${item.id}`} className="text-lg font-medium hover:text-red-500 duration-500 ease-in-out">{item.title}</Link>

                                    <RatingStars avg={item.rating_avg} count={item.rating_count} />

                                    <div className="mt-4 pt-4 flex justify-between items-center border-t border-slate-100 dark:border-gray-800">
                                        <h5 className="text-lg font-medium text-red-500">{formatPrice(item.price_cents, item.currency)}</h5>

                                        <Link to={`/tour-detail-one/${item.id}`} className="text-slate-400 hover:text-red-500">Explorar <i className="mdi mdi-arrow-right"></i></Link>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>

                <div className="mt-6 text-center">
                    <Link to="/grid" className="text-slate-400 hover:text-red-500 inline-block">Ver más tours <i className="mdi mdi-arrow-right align-middle"></i></Link>
                </div>
            </div>

            <About/>

            <Client/>

            <Blogs/>
        </section>
        <Footer/>
        <Switcher/>
        </>
    )
}
